import { Component, OnInit } from '@angular/core';
import { MetaService } from '../meta.service';

@Component({
  selector: 'app-technology',
  templateUrl: './technology.component.html',
  styleUrls: ['./technology.component.css']
})
export class TechnologyComponent implements OnInit {

  //inject services
  constructor(private mds: MetaService) { }

  //initialize the component
  ngOnInit(): void {
    //SEO Optimization
    var strTitle = 'RegScale - Technology';
    var description = 'RegScale technology including APIs, containers, polymorphic deployment, and scalability.';
    var keywords = 'RegScale, APIs, Docker, Kubernetes, ISO, on premises, Infrastructure as Code, Packaging, Angular, .NET Core, SQL Server';
    this.mds.updateTags(strTitle, keywords, description);
  }

}
